// extracted by mini-css-extract-plugin
export default {"main_container":"Wecare_main_container__E12jv"};